"use client";

import React from "react";
import { Skeleton } from "@/components/ui/adapters";

/** Skeleton with same layout as login page: same wrapper and left/right structure. */
export function LoginPageSkeleton(): React.ReactElement {
  return (
    <div className="bg-background-light w-screen h-dvh xl:h-screen flex justify-start print:flex print:justify-start print:mx-auto print:min-h-screen overflow-hidden">
      <div className="w-full h-full flex justify-start print:flex print:justify-start print:mx-auto">
        <div className="w-full h-full flex col-span-1 md:col-span-2 gap-6 p-4 md:p-6 xl:min-h-[500px] overflow-y-hidden">
          <div className="relative w-full flex flex-col gap-6 items-start justify-center lg:pl-[100px] xl:pl-[200px]">
            <div className="absolute top-0 w-full flex flex-col gap-4 justify-start items-start">
              <Skeleton className="h-9 w-28 rounded-xl bg-secondary-light/90" />
            </div>
            <Skeleton className="h-9 lg:h-10 w-56 max-w-full rounded-xl bg-secondary-light/90" />
            <Skeleton className="w-[166px] h-12 rounded-xl bg-secondary-light/90" />
            <div className="flex flex-col gap-2 max-w-sm">
              <Skeleton className="h-3.5 w-full rounded-lg bg-secondary-light/80" />
              <Skeleton className="h-3.5 w-[92%] rounded-lg bg-secondary-light/80" />
            </div>
            <div className="absolute bottom-0 w-full flex flex-col gap-4 justify-start items-start">
              <Skeleton className="h-5 w-44 rounded-lg bg-secondary-light/80" />
              <div className="flex flex-row justify-start items-center gap-4">
                <Skeleton className="h-11 w-[140px] rounded-xl bg-secondary-light/90" />
                <Skeleton className="h-11 w-[140px] rounded-xl bg-secondary-light/90" />
              </div>
            </div>
          </div>
          <div className="w-full flex-col overflow-y-hidden md:rounded-3xl rounded-3xl hidden md:flex bg-secondary-light/70 min-h-[300px]" />
        </div>
      </div>
    </div>
  );
}
